const dropdownCities = [
    {
        val:"" ,
        name: "Select City"
    },
    {
        val: "New York City" ,
        name: "New York City, NY"
    },
    {
        val:"Austin" ,
        name: "Austin, TX"
    },
    {
        val: "Los Angeles" ,
        name: "Los Angeles, CA"
    },
    {
        val: "Huntsville" ,
        name: "Huntsville, AL"
    },
    {
        val: "Raleigh" ,
        name: "Raleigh, NC"
    },
    {
        val: "Jersey City" ,
        name: "Jersey City, NJ"
    },
    {
        val: "Atlanta" ,
        name: "Atlanta, GA"
    },
    {
        val: "Boulder" ,
        name: "Boulder, CO"
    },
    {
        val: "Seattle" ,
        name: "Seattle, WA"
    }
   ]

   export {
    dropdownCities,
   }